const module = {
  config: {
    name: "Users",
    icon: 'account-circle',
    desc: "Data pengaturan pengguna pada Aplikasi",
    layout: true,
    order: 7
  },
  routes: [
    {
      name: 'users',
      icon: 'user-location',
      path: '/users',
      translate_key: 'users',
      component: () => import('./users/users.vue'),
      separator: ''
    },
    {
      name: 'journal-kegiatan',
      icon: 'bookmark-3',
      path: '/journal',
      translate_key: 'journal-kegiatan',
      component: () => import('./journal/journal.vue'),
      separator: ''
    },
    // {
    //   name: 'user-roles',
    //   icon: 'user-location',
    //   path: '/user-roles',
    //   translate_key: 'user-roles',
    //   component: () => import('./user-roles/user-roles.vue'),
    //   separator: ''
    // },
    //  public
    // {
    //   name: 'public',
    //   type: 'parent',
    //   // icon: "user",
    //   redirectName: 'participants',
    //   child: [
    //   ]
    // }
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/users/_index.js